<template>
    <div id="secure" v-if="userData">
        <h1>Meine Daten</h1>

        <table v-if="userData" id="table">
            <tr>
                <th>Firmen-ID</th>
                <td>{{ userData.company.companyId }}</td>
            </tr>
            <tr>
                <th>Vorname</th>
                <td>{{ userData.firstName }}</td>
            </tr>
            <tr>
                <th>Nachname</th>
                <td>{{ userData.lastName }}</td>
            </tr>
            <tr>
                <th>E-Mail</th>
                <td>{{ userData.email }}</td>
            </tr>
            <tr>
                <th>Registrierung</th>
                <td>{{ dateFormat(userData.created, "myDate") }}</td>
            </tr>
            <tr>
                <th>Letzte Änderung</th>
                <td>{{ dateFormat(userData.updated, "myDate") }}</td>
            </tr>
            <tr>
                <th>Firmenname</th>
                <td>{{ userData.company.name }}</td>
            </tr>
            <tr>
                <th>Telefon</th>
                <td>{{ userData.company.phoneNumber }}</td>
            </tr>
            <tr>
                <th>IK</th>
                <td>{{ userData.company.ik }}</td>
            </tr>
            <tr>
                <th>PQ ab</th>
                <td>{{ dateFormat(userData.company.pq_since, "myDate") }}</td>
            </tr>
            <tr>
                <th>PQ bis</th>
                <td>{{ dateFormat(userData.company.pq_until, "myDate") }}</td>
            </tr>
            <tr>
                <th>Versorgungsbereiche</th>
                <td>{{ userData.company.serviceAreas }}</td>
            </tr>
            <tr>
                <th>Adresse</th>
                <td>
                    {{ userData.address.street }} <br>
                    {{ userData.address.postCode }} {{ userData.address.city }} <br>
                    {{ userData.address.country }}
                </td>
            </tr>
            <tr>
                <th>Newsletterabo</th>
                <td>{{ userData.newsletterAccepted? "ja" : "nein" }}</td>
            </tr>
        </table>
        <br>

        <md-button class="md-raised" to="/partner/my_data/edit/">Bearbeiten</md-button>
        <!--<md-button class="md-raised md-accent" v-on:click="reqDelete()">Löschen</md-button>-->

        <md-dialog :md-active.sync="dialDelete">
            <md-dialog-title>
                Sicher löschen?
            </md-dialog-title>
            <md-dialog-content>
                Alle Daten zu diesem Abdruck werden auf dem Sever gelöscht.
            </md-dialog-content>
            <md-dialog-actions>
                <md-button class="md-raised" @click="dialDelete = false">Doch nicht!</md-button>
                <md-button class="md-accent md-raised" onclick="alert('Not yet implemented')">Löschen!</md-button>
            </md-dialog-actions>
        </md-dialog>
    </div>
</template>

<script>
import {dateFormat} from "../helpers/dates";

export default {
    name: 'Partner_Data',
    props: {},
    data: () => ({
        dialDelete: false,
        dateFormat
    }),
    computed: {
        userData: function () {
            return this.$store.state.user
        },
    },
    components: {},
    methods: {
        reqDelete() {
            this.dialDelete = true;
        },
    }
}
</script>

<style scoped>
#secure {
    background-color: #FFFFFF;
    border: 1px solid #CCCCCC;
    padding: 20px;
    margin-top: 10px;
}

table#table {
    display: inline-block;
    border-collapse: collapse;
}

table#table > tr > th {
    font-size: large;
    padding: 10px;
}

table#table > tr > td {
    padding: 10px;
}

table#table > tr:nth-child(odd) {
    background: #EEE;
}

table#table > tr:nth-child(even) {
    background: #FFF;
}
</style>
